import React, { useState, useContext } from "react";
import WidgetContext from './Context';
import Anim from "./Anim";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';



export default function Chat(props) {
  
  
  //console.log(props.chatPersonName);
  const {
    isOpen
  } = useContext(WidgetContext);
  const [chatAnim, setChatAnim] = useState(true);
  const bodyBgColor = props.bodyBgColor ? props.bodyBgColor : '#fff',
        chatTitle = props.chatTitle ? props.chatTitle : 'Select',
        chatPersons = props.chatPersonName,
        chatP = chatPersons.map((cp) =>
         
            <List sx={{ width: '100%', maxWidth: 360 }}>
            <ListItem component="a" href={"https://wa.me/"+cp.phone}  alignItems="flex-start">
              <ListItemAvatar>
              <WhatsAppIcon></WhatsAppIcon>
              </ListItemAvatar>
              <ListItemText
                primary= {cp.name}
                secondary={
                  <React.Fragment>
                    <Typography
                      sx={{ display: 'inline' }}
                      component="span"
                      variant="body2"
                      color="text.primary"
                    >
                     {cp.aka}
                    </Typography>
                    {" — replies within hours"}
                  </React.Fragment>
                }
              />
            </ListItem>
            <Divider variant="inset" component="li" />
           </List>
          );
       // console.log(chatP);
        
  setTimeout(() => {
    isOpen && setChatAnim(false);
  }, 500);
  return /*#__PURE__*/React.createElement("div", {
    key: props,
    className: "whatsapp_widget_chat_wrapper",
    style: {
      backgroundColor: bodyBgColor
    }
  }, chatAnim ? /*#__PURE__*/React.createElement("div", {
    className: "whatsapp_widget_bubble_anim"
  }, /*#__PURE__*/React.createElement("div", {
    className: "whatsapp_widget_bubble_anim_inner"
  }, /*#__PURE__*/React.createElement(Anim, null))) : /*#__PURE__*/React.createElement("div", /*#__PURE__*/React.createElement("div", {
    className: "abc"
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: 'rgba(0, 0, 0, 0.4)'
    }
  }, chatTitle), /*#__PURE__*/React.createElement("div", {
    className: "whatsapp-body",
    style: {
      fontSize: 13,
      color: '#111'
    }
  },chatP), /*#__PURE__*/React.createElement("div", {
    className: "whatsapp-body--li",
    style: {
      fontSize: 13,
      color: 'rgba(0, 0, 0, 0.4)',
      textAlign: 'end',
      marginTop: 5
    }
  })));
}
